<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap align-start>
            <v-flex d-flex sm12 md5>
                <v-layout column>
                    <v-flex>
                        <v-layout row justify-start>
                            <v-icon @click="back" left>mdi-arrow-left</v-icon>
                            <h2>Bruker: {{user.name}}</h2>
                        </v-layout>
                    </v-flex>

                    <v-flex>
                        <v-form v-model="valid">
                            <v-text-field v-model="user.name" :rules="rules.text" label="Navn" :loading="loading" required></v-text-field>
                            <v-text-field v-model="user.username" label="Brukernavn/Epost" :loading="loading" required></v-text-field>
                            <v-text-field v-model="user.phone" label="Tlf" :loading="loading" required></v-text-field>
                            <v-select v-model="user.company" label="Bedrift" :items="companies" item-value="name" item-text="name" :loading="companiesLoading" chips return-object>
                            </v-select>

                            <!-- <v-btn-toggle v-model="user.canLogin" mandatory class="mr-2 elevation-1">
                                <v-btn color="info" :value="1" small style="min-width: 50px;" :loading="loading">ja</v-btn>
                                <v-btn color="info" :value="0" small style="min-width: 50px;" :loading="loading">nei</v-btn>
                            </v-btn-toggle>
                            <span class="body-1 grey--text">Kan brukeren logge på webapplikasjon?</span>
                            <br>
                            <v-btn-toggle v-model="user.rights" mandatory class="mt-2 mr-2 elevation-1">
                                <v-btn color="info" :value="0" small style="min-width: 50px;" :loading="loading">administrator</v-btn>
                                <v-btn color="info" :value="1" small style="min-width: 50px;" :loading="loading">bruker</v-btn>
                            </v-btn-toggle>
                            <span class="body-1 grey--text">Velg brukerettigheter.</span>
                            <br>
                            <v-btn-toggle v-model="user.active" mandatory class="my-2 mr-2 elevation-1">
                                <v-btn color="info" :value="1" small style="min-width: 50px;" :loading="loading">ja</v-btn>
                                <v-btn color="info" :value="0" small style="min-width: 50px;" :loading="loading">nei</v-btn>
                            </v-btn-toggle>
                            <span class="body-1 grey--text">Er brukeren aktivt?</span> -->
                            <br>

                            <br>
                            <div class="body-1">Bruker rettigheter:</div>
                            <hr>

                            <v-radio-group v-model="user.canLogin">
                                <v-radio :value=1>
                                    <template v-slot:label>
                                        <div>Bruker kan logge inn i Gatebrains.</div>
                                    </template>
                                </v-radio>
                                <v-radio :value=0>
                                    <template v-slot:label>
                                        <div>Bruker kan ikke logge inn i Gatebrains.</div>
                                    </template>
                                </v-radio>
                            </v-radio-group>

                            <hr>

                            <v-radio-group v-model="user.rights">
                                <v-radio :value=1>
                                    <template v-slot:label>
                                        <div>Vanlig bruker.</div>
                                    </template>
                                </v-radio>
                                <v-radio :value=0>
                                    <template v-slot:label>
                                        <div>Administrator.</div>
                                    </template>
                                </v-radio>
                            </v-radio-group>

                            <hr>

                            <v-radio-group v-model="user.active">
                                <v-radio :value=1>
                                    <template v-slot:label>
                                        <div>Bruker er aktivt (synlig systemet og kan logge inn).</div>
                                    </template>
                                </v-radio>
                                <v-radio :value=0>
                                    <template v-slot:label>
                                        <div>Bruker er inaktivt (er usynlig i systemet og kan ikke logge inn).</div>
                                    </template>
                                </v-radio>
                            </v-radio-group>

                            <!-- <v-switch v-model="user.active" label="Aktivert"></v-switch> -->
                            <div style="display: flex; flex-flow: row; align-items: center;">
                                <v-btn :disabled="!hasChanged || saving" :loading="saving" color="error lighten-2" @click="cancel">Angre</v-btn>
                                <v-btn :disabled="!hasChanged || saving" :loading="saving" color="success" @click="submit" class="ml-2">Lagre</v-btn>
                            </div>

                        </v-form>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex d-block sm12 md7>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-layout row mx-4 mt-2>
                            <!-- <v-icon>vpn_key</v-icon> -->
                            <v-chip class="headline mb-3" outlined pill label style="border-width: 0px;">
                                <v-avatar color="info" left>
                                    <span class="white--text">{{this.accessCodes.length}}</span>
                                </v-avatar>

                                <span>Eksisterende ringetilganger</span>
                                <!-- <v-btn small fab color="info" class="elevation-0" style="cursor:default">{{this.accessCodes.length}}</v-btn> -->
                            </v-chip>
                        </v-layout>

                        <v-expansion-panels popout>
                            <v-expansion-panel :disabled="accessCodes.filter(i => i.type == 1).length == 0">
                                <v-expansion-panel-header>
                                    <v-chip :style="{cursor:'pointer'}" color="info lighten-1" text-color="white" pill>
                                        <v-avatar left class="info darken-1">
                                            {{accessCodes.filter(i => i.type == 1).length}}
                                        </v-avatar>
                                        Gyldig mellom to tidspunkter
                                    </v-chip>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-data-table v-if="accessCodes.filter(i => i.type == 1).length > 0" :items="accessCodes.filter(i => i.type == 1)" :headers="access.headersDate" hide-actions hide-default-footer :items-per-page="-1">
                                        <template v-slot:item={item}>
                                            <tr>
                                                <td>{{moment.unix(item.start).format('HH:mm @ DD.MM.YY')}}</td>
                                                <td>{{moment.unix(item.end).format('HH:mm @ DD.MM.YY')}}</td>
                                                <td>{{item.reuse}}</td>
                                                <td>{{item.claims}}</td>
                                                <td>{{moment.unix(item.created_at).local().format('HH:mm @ DD.MM.YY')}}</td>
                                                <td>
                                                    <v-icon small @click="deleteAccessCode(item.id)">mdi-delete</v-icon>
                                                    <v-icon small @click="copyAccessCode(item)">mdi-content-copy</v-icon>
                                                    <v-icon v-if="hasNildevices" small @click="requestNilkey(item.id)">mdi-bluetooth</v-icon>

                                                </td>
                                            </tr>

                                        </template>
                                    </v-data-table>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel :disabled="accessCodes.filter(i => i.type == 3).length == 0">
                                <v-expansion-panel-header>
                                    <v-chip :style="{cursor:'pointer'}" color="info lighten-1" text-color="white" pill>
                                        <v-avatar left class="info darken-1">
                                            {{accessCodes.filter(i => i.type == 3).length}}
                                        </v-avatar>
                                        Gyldig visse dager i uken
                                    </v-chip>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-data-table v-if="accessCodes.filter(i => i.type == 3).length > 0" :items="accessCodes.filter(i => i.type == 3)" :headers="access.headersDayOfWeek" hide-actions hide-default-footer :items-per-page="-1">
                                        <template v-slot:item={item}>
                                            <tr>
                                                <td v-if="item.type == 3">{{(Math.floor(item.from/60)).toString().padStart(2,'0')}}:{{(item.from%60).toString().padStart(2,'0')}}</td>
                                                <td v-if="item.type == 3">{{(Math.floor(item.to/60)).toString().padStart(2,'0')}}:{{(item.to%60).toString().padStart(2,'0')}}</td>
                                                <td v-if="item.type == 3">{{dayOfWeek(item.dayOfWeek)}}</td>
                                                <td>{{item.reuse}}</td>
                                                <td>{{item.claims}}</td>
                                                <td>{{moment.unix(item.created_at).local().format('HH:mm @ DD.MM.YY')}}</td>
                                                <td>
                                                    <v-icon small @click="deleteAccessCode(item.id)">mdi-delete</v-icon>
                                                    <v-icon small @click="copyAccessCode(item)">mdi-content-copy</v-icon>
                                                    <v-icon v-if="hasNildevices" small @click="requestNilkey(item.id)">mdi-bluetooth</v-icon>

                                                </td>
                                            </tr>

                                        </template>
                                    </v-data-table>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel :disabled="accessCodes.filter(i => i.type == 2).length == 0">
                                <v-expansion-panel-header>
                                    <v-chip :style="{cursor:'pointer'}" color="info lighten-1" text-color="white" pill>
                                        <v-avatar left class="info darken-1">
                                            {{accessCodes.filter(i => i.type == 2).length}}
                                        </v-avatar>
                                        Alltid gyldig
                                    </v-chip>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-data-table :items="accessCodes.filter(i => i.type == 2)" :headers="access.headersOpen" hide-default-footer :items-per-page="-1" v-if="accessCodes.filter(i => i.type == 2).length > 0">
                                        <template v-slot:item="{item}">
                                            <tr>
                                                <td>{{item.reuse}}</td>
                                                <td>{{item.claims}}</td>
                                                <td>{{moment.unix(item.created_at).local().format('HH:mm @ DD.MM.YY')}}</td>
                                                <td>
                                                    <v-icon small @click="deleteAccessCode(item.id)">mdi-delete</v-icon>
                                                    <v-icon small @click="copyAccessCode(item)">mdi-content-copy</v-icon>
                                                    <v-icon v-if="hasNildevices" small @click="requestNilkey(item.id)">mdi-bluetooth</v-icon>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                    </v-flex>
                    <v-flex xs12 class="mt-5 mx-4">
                        <v-layout column>
                            <v-divider class="mt-5"></v-divider>
                            <v-chip class="headline my-3" outlined pill label style="border-width: 0px;">
                                <v-avatar left>
                                    <v-icon color='green' large>mdi-playlist-plus</v-icon>
                                </v-avatar>
                                Legg til ny ringetilgang
                            </v-chip>
                            <v-flex>
                                <v-btn-toggle v-model="access.dateType" mandatory class="elevation-1">
                                    <v-btn>Dato</v-btn>
                                    <v-btn>Dager i uken</v-btn>
                                    <v-btn>Alltid</v-btn>
                                </v-btn-toggle>
                            </v-flex>

                            <v-form ref="form" class="mt-2" v-model="access.valid">
                                <v-text-field v-if="access.dateType == 0" label="Fra" type="datetime-local" v-model="access.start" @change="timeChanged" :rules="[v => !!v || 'Påkrevd', v => (!this.access.end || moment(this.access.start) < moment(this.access.end)) || 'Fra må være mindre en Til']"></v-text-field>
                                <v-text-field v-if="access.dateType == 0" label="Til" type="datetime-local" v-model="access.end" @change="timeChanged" :rules="[v => !!v || 'Påkrevd', v => (!this.access.start || moment(this.access.start) < moment(this.access.end)) || 'Til må være større en Fra']"></v-text-field>
                                <div v-if="access.dateType == 1">
                                    <v-input :error="access.daysOfWeek.length === 0" :error-messages="access.daysOfWeek.length === 0 ? 'Velg minst en dag' : []">
                                        <v-btn-toggle :error="true" v-model="access.daysOfWeek" multiple class="elevation-1">
                                            <v-btn>Mandag</v-btn>
                                            <v-btn>Tirsdag</v-btn>
                                            <v-btn>Onsdag</v-btn>
                                            <v-btn>Torsdag</v-btn>
                                            <v-btn>Fredag</v-btn>
                                            <v-btn>Lørdag</v-btn>
                                            <v-btn>Søndag</v-btn>
                                        </v-btn-toggle>
                                    </v-input>
                                    <div>
                                        <v-btn small class="ma-1" color="info" @click="alldays">Alle</v-btn>
                                        <v-btn small class="ma-1" color="info" @click="weekdays">Hverdager</v-btn>
                                        <v-btn small class="ma-1" color="info" @click="nodays">Ingen</v-btn>
                                    </div>
                                    <v-text-field ref="dowFrom" label="Fra" type="time" v-model="access.from" @change="timeChanged" :rules="[v => !!v || 'Påkrevd', v => (!this.access.to || this.access.from < this.access.to) || 'Fra må være mindre en Til']"></v-text-field>
                                    <v-text-field ref="dowTo" label="Til" type="time" v-model="access.to" @change="timeChanged" :rules="[v => !!v || 'Påkrevd', v => (!this.access.from || this.access.from < this.access.to) || 'Til må være større en Fra']"></v-text-field>
                                </div>

                                <v-text-field v-model="access.codeReuse" type="number" :rules="[v => !!v || 'Påkrevd' , v => v <= 9999 || 'Maks er 9999']" label="Gjenbruk av kode (maks 9999)"></v-text-field>
                                <!-- <v-btn color="warning" @click="cancel_accessCode">Angre</v-btn> -->
                                <v-btn color="green" class="white--text" @click="submit_accessCode" :disabled="!access.valid || (access.dateType == 1 && access.daysOfWeek.length == 0)">
                                    Legg til ringetilgang
                                </v-btn>

                            </v-form>
                        </v-layout>

                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
// import axios from "axios";
import * as equalizer from "../utilities/equalizer.js";
import moment from "moment";

export default {
    props: ["id"],
    data() {
        return {
            hasNildevices: false,
            user: {
                id: 0,
                name: "",
                username: "",
                phone: "",
                company: { id: 0, name: "" },
                canLogin: false,
                rights: 0,
                active: false
            },
            originalUser: {
                id: 0,
                name: "",
                username: "",
                phone: "",
                company: { id: 0, name: "" },
                canLogin: false,
                rights: 0,
                active: false
            },
            companies: [],
            valid: true,
            accessCodes: [],
            rules: {
                text: [v => !!v || "Påkrevd"],
                email: [v => (!!v && v.length > 0) || "Epost påkrevd", v => /.+@.+\..+/.test(v) || "Ugyldig epost"]
            },
            saving: false,
            loading: false,
            companiesLoading: false,
            accessCodesLoading: false,
            access: {
                valid: false,
                dateType: 2,
                start: "",
                end: "",
                daysOfWeek: [],
                from: "",
                to: "",
                codeReuse: 9999,
                headersDate: [
                    { text: "Fra", value: "start" },
                    { text: "Til", value: "end" },
                    { text: "Gjenbruk", value: "reuse" },
                    { text: "Brukt", value: "claims" },
                    { text: "Tildelt dato", value: "created_at" },
                    { text: "Handlinger", sortable: false }
                ],
                headersDayOfWeek: [
                    { text: "Fra", value: "start" },
                    { text: "Til", value: "end" },
                    { text: "Dager i uken", value: "dayOfWeek" },
                    { text: "Gjenbruk", value: "reuse" },
                    { text: "Brukt", value: "claims" },
                    { text: "Tildelt dato", value: "created_at" },
                    { text: "Handlinger", sortable: false }
                ],
                headersOpen: [
                    { text: "Gjenbruk", value: "reuse" },
                    { text: "Brukt", value: "claims" },
                    { text: "Tildelt dato", value: "created_at" },
                    { text: "Handlinger", sortable: false }
                ]
            }
        };
    },
    computed: {
        hasChanged: function() {
            return !equalizer.propertiesEqual(
                [
                    { prop: "name", strict: true },
                    { prop: "username", strict: true },
                    { prop: "phone", strict: true },
                    { prop: "company.id", strict: true },
                    { prop: "canLogin", strict: false },
                    { prop: "rights", strict: false },
                    { prop: "active", strict: false }
                ],
                this.user,
                this.originalUser
            );
        }
    },
    methods: {
        timeChanged: function() {
            this.$refs.form.validate();
        },
        back: function() {
            this.$router.go(-1);
        },
        cancel: function() {
            Object.assign(this.user, this.originalUser);
            this.$store.commit("snackbar", {
                text: `Angret.`,
                color: "warning",
                show: true
            });
        },
        submit: function() {
            this.saving = true;
            this.user.company_id = this.user.company ? this.user.company.id : undefined;
            this.axios
                .post(`/user/${this.id}`, this.user)
                .then(response => {
                    if (response.data.success) {
                        Object.assign(this.originalUser, this.user);
                        this.$store.commit("snackbar", {
                            text: `Lagret.`,
                            color: "success",
                            show: true
                        });
                    }
                })
                .catch(() => {
                    // console.log(err);
                    this.$store.commit("snackbar", {
                        text: `Feil oppstatt - ikke lagret.`,
                        color: "error",
                        show: true
                    });
                })
                .then(() => {
                    this.saving = false;
                });
        },
        submit_accessCode: function() {
            if (this.access.dateType == 1 && (!this.access.daysOfWeek || this.access.daysOfWeek.length == 0)) {
                this.$store.commit("snackbar", {
                    text: `Velg minst en dag.`,
                    color: "error",
                    show: true
                });
                return;
            }

            // NEW SAVE
            var accessCode;
            switch (this.access.dateType) {
                case 0: {
                    // date -> 2
                    accessCode = {
                        user_id: this.id,
                        type: 1,
                        start: moment(this.access.start).unix(),
                        end: moment(this.access.end).unix(),
                        reuse: this.access.codeReuse
                    };
                    break;
                }
                case 1: {
                    // day of week -> 3
                    let dow = this.access.daysOfWeek.map(d => {
                        if (d >= 0 && d <= 5) return d + 2;
                        else return 1;
                    });
                    let dowStringWithoutBrackets = dow.reduce((accumulator, currentValue) => {
                        return `${accumulator},${currentValue}`;
                    });
                    let dowString = `${dowStringWithoutBrackets}`;

                    let from = Number(this.access.from.split(":")[0]) * 60 + Number(this.access.from.split(":")[1]);
                    let to = Number(this.access.to.split(":")[0]) * 60 + Number(this.access.to.split(":")[1]);

                    accessCode = {
                        user_id: this.id,
                        type: 3,
                        from: from,
                        to: to,
                        dayOfWeek: dowString,
                        reuse: this.access.codeReuse
                    };
                    break;
                }
                case 2: {
                    // open -> 1
                    accessCode = {
                        user_id: this.id,
                        type: 2,
                        reuse: this.access.codeReuse
                    };
                    break;
                }
            }

            this.axios
                .put("/accesscode", accessCode)
                .then(response => {
                    if (response.data.success) {
                        this.$store.commit("snackbar", {
                            text: `Lagret.`,
                            color: "success",
                            show: true
                        });

                        this.fetchAccessCodes(this.id);
                        this.clearAccessCode();
                    } else {
                        this.$store.commit("snackbar", {
                            text: `Ikke lagret.`,
                            color: "error",
                            show: true
                        });
                    }
                })
                .catch(() => {
                    this.$store.commit("snackbar", {
                        text: `Ikke lagret.`,
                        color: "error",
                        show: true
                    });
                });
        },
        cancel_accessCode: function() {
            this.clearAccessCode();
        },
        copyAccessCode: function(accessCode) {
            this.clearAccessCode();

            switch (accessCode.type) {
                case 2: // open
                    this.access.dateType = 2;
                    this.access.codeReuse = accessCode.reuse;
                    break;
                case 1: // date
                    this.access.dateType = 0;
                    // "2018-02-01T10:10"
                    this.access.start = moment.unix(accessCode.start).format("YYYY-MM-DDTHH:mm");
                    this.access.end = moment.unix(accessCode.end).format("YYYY-MM-DDTHH:mm");
                    this.access.codeReuse = accessCode.reuse;
                    break;
                case 3: // dow
                    this.access.dateType = 1;
                    this.access.from = accessCode.from;
                    this.access.to = accessCode.to;
                    this.access.codeReuse = accessCode.reuse;

                    this.access.daysOfWeek = accessCode.dayOfWeek
                        // .substring(1, accessCode.dayOfWeek.length - 1)
                        .split(",")
                        .map(d => {
                            if (d >= 2 && d <= 7) {
                                return d - 2;
                            } else {
                                return 6;
                            }
                        });
                    break;
            }
        },
        deleteAccessCode: function(id) {
            if (id) {
                let accessCode = this.accessCodes.find(a => a.id === id);
                if (accessCode) {
                    this.axios
                        .delete(`/accesscode/${id}`)
                        .then(response => {
                            if (response.data.success) {
                                let index = this.accessCodes.indexOf(accessCode);
                                this.accessCodes.splice(index, 1);

                                this.$store.commit("snackbar", {
                                    text: `Slettet.`,
                                    color: "success",
                                    show: true
                                });
                            } else {
                                this.$store.commit("snackbar", {
                                    text: `Ikke slettet.`,
                                    color: "error",
                                    show: true
                                });
                            }
                        })
                        .catch(() => {
                            this.$store.commit("snackbar", {
                                text: `Ikke slettet.`,
                                color: "error",
                                show: true
                            });
                        });
                    // this.fetchAccessCodes(this.id);
                }
            }
        },
        clearAccessCode: function() {
            this.access.start = "";
            this.access.end = "";
            this.access.from = "";
            this.access.to = "";
            this.access.daysOfWeek = [];
            this.access.codeReuse = 1;
        },
        fetchAccessCodes: function() {
            this.accessCodesLoading = true;
            this.axios
                .get(`/accesscode?userid=${this.id}`)
                .then(response => {
                    this.accessCodes = response.data.data;
                })
                .catch(() => {
                    // console.log(err);
                })
                .finally(() => {
                    this.accessCodesLoading = true;
                });
        },
        alldays: function() {
            this.access.daysOfWeek = [0, 1, 2, 3, 4, 5, 6];
        },
        weekdays: function() {
            this.access.daysOfWeek = [0, 1, 2, 3, 4];
        },
        nodays: function() {
            this.access.daysOfWeek = [];
        },
        dayOfWeek: function(dayOfWeekString) {
            if (!dayOfWeekString) return [];

            // let dow = dayOfWeekString.substring(1, dayOfWeekString.length - 1);
            let dow = dayOfWeekString;
            let days = dow.split(",").sort();
            let daysAsStrings = days.map(day => {
                switch (Number(day)) {
                    case 1:
                        return "søn";
                    case 2:
                        return "mon";
                    case 3:
                        return "tirs";
                    case 4:
                        return "ons";
                    case 5:
                        return "tors";
                    case 6:
                        return "fre";
                    case 7:
                        return "lør";
                }
            });

            let result = daysAsStrings.reduce((accumulator, currentValue) => {
                return `${accumulator}, ${currentValue}`;
            });

            return result;
        },
        requestNilkey: function(accessCodeId) {
            this.axios.post("/nil/nilify", { accessCodeId: accessCodeId, email: this.user.username });
        }
    },
    async mounted() {
        this.loading = true;
        this.companiesLoading = true;
        this.axios
            .get(`/user/${this.id}`)
            .then(response => {
                if (response.data.success) {
                    Object.assign(this.user, response.data.data);
                    Object.assign(this.originalUser, response.data.data);
                } else {
                    throw new Error("something went wrong");
                }
            })
            .catch(() => {
                // console.log(err);
            })
            .finally(() => {
                this.loading = false;
            });

        this.axios
            .get("/company")
            .then(response => {
                if (response.data.success) {
                    this.companies = response.data.data;
                } else {
                    throw new Error("something went wrong");
                }
            })
            .catch(() => {
                // console.log(err);
            })
            .finally(() => {
                this.companiesLoading = false;
            });

        this.fetchAccessCodes(this.id);

        let response = await this.axios.get("/nil/count");
        if (response.data.success && response.data?.message.count) {
            this.hasNildevices = true;
        }
    },
    watch: {
        access: {
            handler: function() {},
            deep: true
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>

<style scoped>
</style>
